import React from 'react';
import './Hero.css';
import NetworkThree from '../network/NetworkThree';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-inner container">
        <div className="hero-copy">
          <h1 className="hero-title">Infrastructure for the Intelligent World</h1>
          <p className="hero-sub">Where Impact Meets Technology — AI, XR, and sustainable systems shaping cities and infrastructure at scale.</p>
          <div className="hero-ctas">
            <a href="/projects" className="btn btn-primary" aria-label="View projects">Explore Projects</a>
            <a href="/contact" className="btn btn-outline" aria-label="Contact Goodness">Get in Touch</a>
          </div>
        </div>
        <div className="hero-visual" aria-hidden>
          <div className="network-panel">
            <NetworkThree />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;